import bannerStrand from '../../assets/images/Banner_Strand.png'
import usaFlag from '../../assets/images/usa-flag.svg'
import dscsaPackingSlip from '../../assets/images/DSCSA_Packing_Slip.jpg'

export const dscsaContent = {
    "sys": {
      "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
      {
        "fields": {
          "name": "DSCSA Compliance",
          "title": "DSCSA Compliance ",
          "slug": "dscsa",
          "content": {
            "metadata": {
              "tags": [],
              "concepts": []
            },
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "n9bebhw263o0"
                }
              },
              "id": "idiTg3bhIc667MIjHnnfL",
              "type": "Entry",
              "createdAt": "2024-05-09T16:41:13.680Z",
              "updatedAt": "2024-05-09T16:41:13.680Z",
              "environment": {
                "sys": {
                  "id": "sandbox",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "publishedVersion": 4,
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "richTextContentPageTemplate"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "name": "DSCSA > Content",
              "modules": [
                {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "6F3Xyxxs4LJIlbJlKLpBKK",
                    "type": "Entry",
                    "createdAt": "2024-05-09T16:40:45.214Z",
                    "updatedAt": "2024-07-01T18:12:53.240Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 8,
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "bannerComponent"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "DSCSA > Content > Banner",
                    "headline": "Welcome to Moderna DSCSA Support",
                    "backgroundImage": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "5zfGJA7or5WGcLdYi4Qde",
                        "type": "Asset",
                        "createdAt": "2022-10-28T18:53:29.208Z",
                        "updatedAt": "2022-10-28T18:53:29.208Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 6,
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Banner BG Strand Top",
                        "description": "",
                        "file": {
                          "url": bannerStrand,
                          "details": {
                            "size": 47693,
                            "image": {
                              "width": 1920,
                              "height": 511
                            }
                          },
                          "fileName": "Banner BG Strand Top .png",
                          "contentType": "image/png"
                        }
                      }
                    },
                    "message": "Welcome to Moderna DSCSA Support",
                    "country": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "7iOWBmppZrkK5s40UUIzOV",
                        "type": "Entry",
                        "createdAt": "2023-09-28T22:24:03.948Z",
                        "updatedAt": "2023-09-28T22:24:03.948Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 3,
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "country"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "name": "United States",
                        "isocode": "US",
                        "flag": {
                          "metadata": {
                            "tags": [],
                            "concepts": []
                          },
                          "sys": {
                            "space": {
                              "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                              }
                            },
                            "id": "3aYCbZJiL8aoEKRdhjOXyy",
                            "type": "Asset",
                            "createdAt": "2023-05-24T22:54:50.939Z",
                            "updatedAt": "2023-05-24T22:54:50.939Z",
                            "environment": {
                              "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                              }
                            },
                            "publishedVersion": 5,
                            "revision": 1,
                            "locale": "en-US"
                          },
                          "fields": {
                            "title": "usa flag",
                            "description": "USA Flag",
                            "file": {
                              "url": usaFlag,
                              "details": {
                                "size": 2487,
                                "image": {
                                  "width": 36,
                                  "height": 26
                                }
                              },
                              "fileName": "usa_flag.svg",
                              "contentType": "image/svg+xml"
                            }
                          }
                        },
                        "locales": [
                          "en-US"
                        ]
                      }
                    }
                  }
                },
                {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "1zPq5CtQ172JvXpumOhHu1",
                    "type": "Entry",
                    "createdAt": "2024-05-09T16:40:49.131Z",
                    "updatedAt": "2024-07-01T18:12:43.160Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 11,
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "richTextContentComponent"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "DSCSA > Content > Rich Text ",
                    "content": {
                      "nodeType": "document",
                      "data": {},
                      "content": [
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Thank you for choosing Moderna. As part of the United States’ Drug Supply Chain Security Act (DSCSA), our customers are responsible for ensuring receipt of the DSCSA TI/TS report as part of the commercial goods receipt process.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Title II of Drug Quality and Security Act (DQSA), also known as the DSCSA, requires that Moderna provide an electronic report with transaction information (TI) and transaction statements (TS) of any Moderna goods you have purchased directly from Moderna.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "How do I request DSCSA information?",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "To access your DSCSA data, please click ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://moderna-prod.launchpad.cfapps.eu10.hana.ondemand.com/0f1c354a-a297-416f-9fac-a7f9a6ebac3c.customerportal.customerportal-0.0.1/index.html"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "here",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": ".",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "For any inquiries about your DSCSA data, please contact Moderna Customer Care Support at:",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:WeCare@modernatx.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "WeCare@modernatx.com",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "1-866-MODERNA or 1-866-663-3762\nMonday to Friday\n8:00am to 8:00pm EDT",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Please be prepared to provide your Customer Care Representative with the following four pieces of delivery identification characteristics which can be found on your shipment packing slip:",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "ordered-list",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "'Sold To' or 'Ship To' Company Name",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Delivery Number",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Lot Number",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "‘Sold To’ or ‘Ship To’ Zip Code",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Please note:",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "unordered-list",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "All above data must exactly match the information located on the packing slip.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "The Lot Number is equivalent to the Batch Number.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "3lZwlO7cRZcQQ4WPVrEHbd",
                                "type": "Asset",
                                "createdAt": "2024-07-01T18:12:34.753Z",
                                "updatedAt": "2024-07-01T18:12:34.753Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 4,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "DSCSA Packing Slip",
                                "description": "",
                                "file": {
                                  "url": dscsaPackingSlip,
                                  "details": {
                                    "size": 272550,
                                    "image": {
                                      "width": 1241,
                                      "height": 895
                                    }
                                  },
                                  "fileName": "DSCSA Packing Slip.jpg",
                                  "contentType": "image/jpeg"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "I did not receive my data, or the data received is incorrect.",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Please reach out to Moderna Customer Care Support for assistance. Be prepared to provide your key delivery identification characteristics (Company Name, Delivery Number, Lot/Batch Number, ‘Sold To’/’Ship To’ Zip Code) to allow your Customer Care Team Representative to open an investigation of your DSCSA data.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        }
                      ]
                    },
                    "printButtonLabel": "Print",
                    "country": "[Circular Reference]"
                  }
                }
              ]
            }
          }
        },
        "sys": {
          "id": "1gyRTfI0RX6WX66ITwL9uA",
          "type": "Entry"
        }
      }
    ],
    "includes": {
      "Entry": [
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]"
      ],
      "Asset": [
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]"
      ]
    }
  }
